import _CapabilitiesEditor from '../_internal/components/CapabilitiesEditor';
export const CapabilitiesEditor = _CapabilitiesEditor;
export { ChannelLabel } from '../_internal/components/ChannelLabel';
import _DisabledEditor from '../_internal/components/disabled-editor/DisabledEditor';
export const DisabledEditor = _DisabledEditor;